export default function identity(d) {
  var unknown;
  var domain = [];

  function scale(x) {
    return x == null ? unknown : x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function (v) {
    if (v) {
      domain = v;
      return v;
    }

    return domain;
  };

  scale.unknown = function (v) {
    if (v) {
      unknown = v;
      return v;
    }

    return unknown;
  };

  scale.copy = function () {
    return identity(d).unknown(unknown);
  };

  return scale;
}